import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@workspace/ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@workspace/ui/components/form";
import { Input } from "@workspace/ui/components/input";
import { useForm } from "react-hook-form";
import { Loading } from "@/components/loading";
import {
  defaultUserLoginValues,
  UserLoginSchema,
  type UserLoginValues,
} from "@/lib/schemas/login";

type EmailLoginFormProps = {
  disabled?: boolean;
  formId?: string;
  loading: boolean;
  onSubmit: (data: UserLoginValues) => Promise<void>;
  showLastUsed?: boolean;
  submitLabel?: string;
};

export function EmailLoginForm({
  disabled,
  formId,
  loading,
  onSubmit,
  showLastUsed = false,
  submitLabel = "Send magic link",
}: EmailLoginFormProps) {
  const form = useForm<UserLoginValues>({
    mode: "onSubmit",
    resolver: zodResolver(UserLoginSchema),
    defaultValues: defaultUserLoginValues,
  });

  return (
    <div className="relative">
      {showLastUsed ? (
        <div className="pointer-events-none absolute top-0 right-0">
          <span className="text-[10px] text-muted-foreground">Last used</span>
        </div>
      ) : null}
      <Form {...form}>
        <form
          className="space-y-3"
          id={formId}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email address</FormLabel>
                <FormControl>
                  <Input placeholder="name@example.com" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <Button
            className="w-full"
            disabled={disabled || loading}
            type="submit"
          >
            {loading ? (
              <Loading className="mr-2 size-4 animate-spin" />
            ) : (
              <span>{submitLabel}</span>
            )}
          </Button>
        </form>
      </Form>
    </div>
  );
}
